(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/omit', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/omit'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.omit, global.convert);
    global.omit = mod.exports;
  }
})(this, function (exports, _omit2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.omit = undefined;

  var _omit3 = _interopRequireDefault(_omit2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object omitting specified properties.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...(string|string[])} [paths] The property paths to omit.
   * @return {Object} Returns the updated object.
   * @example omit({ nested: { a: 1, b: 2, c: 3 } }, 'nested', 'b') // => { nested: { a:1, c: 3 } }
   * @see {@link https://lodash.com/docs#omit|lodash.omit} for more information.
   * @since 0.3.0
   */
  var omit = (0, _convert.convert)(_omit3.default);
  exports.omit = omit;
  exports.default = omit;
});